import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmulatemin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.04 22.5H3.96a2.464 2.464 0 0 1-2.46-2.46v-3.282h1.64v3.281c0 .452.369.82.82.82h16.08c.451 0 .82-.368.82-.82V3.961a.821.821 0 0 0-.82-.82H3.96a.821.821 0 0 0-.82.82v3.281H1.5V3.961A2.464 2.464 0 0 1 3.96 1.5h16.08a2.464 2.464 0 0 1 2.46 2.46v16.08a2.464 2.464 0 0 1-2.46 2.46Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "m11.344 17.098-1.16-1.16L13.3 12.82H1.5v-1.64h11.8l-3.116-3.117 1.16-1.16L16.44 12l-5.097 5.098Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgEmulatemin);
export { ForwardRef as ReactComponent };
